<template>
  <header :class="{ 'scrolled-nav': scrolledNav }">
    <nav>
      <div class="nav-container">
      <div class="logo">
                <a href="#">&ltOŚ/&gt </a>
            </div>
      <ul v-show="!mobile" class="navigation">
                <li><a href="#home" class="menu-btn">Strona główna</a></li>
                <li><a href="#about" class="menu-btn">O mnie</a></li>
                <li><a href="#services" class="menu-btn">Usługi</a></li>
                <li><a href="#portfolio" class="menu-btn">Projekty</a></li>
                <li><a href="#contact" class="menu-btn">Kontakt</a></li>
      </ul>
      <div class="icon">
        <i @click="toggleMobileNav()" v-show="mobile" class="far fa-bars" :class="{ 'open-icon-active' : mobileNav }"></i>
        <span @click="toggleMobileNav()" v-show="mobile" class="material-icons" :class="{'close-icon-active' : mobileNav }"> close </span>
      </div>
        
      </div>
      <transition name="mobile-nav">  
        <ul v-show="mobileNav && scrolledMobileNav" class="dropdown-nav">
          <li><a href="#home" class="menu-btn" @click="closeNav">Strona główna</a></li>
          <li><a href="#about" class="menu-btn" @click="closeNav">O mnie</a></li>
          <li><a href="#services" class="menu-btn" @click="closeNav">Usługi</a></li>
          <li><a href="#portfolio" class="menu-btn" @click="closeNav">Portfolio</a></li>
          <li><a href="#contact" class="menu-btn" @click="closeNav">Kontakt</a></li>
       </ul>
      </transition>
    </nav>
  </header>
  
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      scrolledNav: null,
      mobile: false,
      mobileNav: null,
      windowWidth: null,
    };
  },
beforeMount() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
     mounted(){
      window.addEventListener("scroll", this.updateScroll);

      const openIcon = document.querySelector('i')
      const closeIcon = document.querySelector('span')

      openIcon.addEventListener('click', function(){
        openIcon.classList.add('rotate')
      })
    },

  methods: {
    toggleMobileNav() {
      this.mobileNav = !this.mobileNav
    },

    updateScroll() {
      const scrollPosition = window.scrollY;
      if(scrollPosition > 15) {
        this.scrolledNav = true;
        return;
      }
      this.scrolledNav = false;
    },
  
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 768) {
        this.mobile = true;
        return;
      } 
        this.mobile = false;
        this.mobileNav = false;
        return;
    },

    closeNav() {
        this.mobileNav = false;
    },

    scrolledMobileNav() {
      // if(this.mobileNav === true){
        window.addEventListener("scroll", this.closeNav);
      // }
    }
  },
};
</script>

<style lang="scss" scoped>

header {

  z-index: 99;
  width: 100%;
  position: fixed;
  transition: .5s ease all;
  color: #fff;
}

nav {
   position: relative;
    top: 0;
    left: 0;
    width: 100%;
    padding: 1.85rem 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    letter-spacing: 0.5px;
    transition: .5s ease all;
}

   .nav-container {
        display: flex;
        justify-content: space-between;
        width: 70%;
    }

.navigation {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
}

 .logo {
        display: flex;
        align-items: center;

          a {
            font-size: 1.85rem;
            @media(max-width: 425px) {
              font-size: 1.7rem;
            }
          }
          
            a::after {
              content: '',
            }
            a::before {
              content: '',
            }
        }
        ul {
            display: flex;
            list-style: none;
            align-items: center;
        }
            li {
                padding: 0.2rem 1rem;
            }
                a {
                    color: #fff;
                    text-decoration: none;
                    font-size: 1.1rem;
                }
                a::before {
                    display: inline-block;
                    position: relative;
                    font-family: 'work sans', sans-serif;
                     margin-right: 6px;
                    content: '[';
                    opacity: 0;
                    font-weight: 300;
                    top: -1px;
                    transform: translateX(20px);
                    transition: transform 0.3s,opacity 0.20s;
                    
                }
                a::after {
                    display: inline-block;
                    position: relative;
                    font-family: 'work sans', sans-serif;
                    margin-left: 6px;
                    content: ']';
                    opacity: 0;
                    font-weight: 300;
                    top: -1px;
                    transform: translateX(-20px);
                    transition: transform 0.3s,opacity 0.20s;
                }
                a:hover::before {
                    opacity: 1;
                    transform: translateX(0px);
                }
                a:hover::after {
                    opacity: 1;
                    transform: translateX(0px);
                }







.icon {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 24px;
  height: 100%;
  z-index: 2;
}

.icon i {
  font-size: 37px;
  display: block;
  transition: .3s ease all;
  cursor: pointer;
}

.icon span{
  font-size: 35px;
  display: none;
  cursor: pointer;
    color: #fff;
  transition: .3s ease all;
}

.icon .icon-active {
  transform: rotate(90deg);
   transition: .3s ease all;
}
.icon .close-icon-active {
  transform: rotate(90deg);
   transition: .3s ease all;
}



.icon .close-icon-active {
   color: #000;
   transform: rotate(90deg);
}

.icon .open-icon-active {
  display: none;
  transform: rotate(90deg);
  transition: .5s;
}

.icon .close-icon-active{
  display: block;
  transform: rotate(90deg);
   transition: .5s;
}

.dropdown-nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 768px;
  height: 100%;
  background-color: #fff;
}

@keyframes textAppear {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.dropdown-nav li {
  padding: 0.7rem;
}


.dropdown-nav li a {
  font-size: 1.2rem;
  font-weight: 500;
  color: #000;
}

.dropdown-nav li a:hover {
  font-weight: bolder;
}

.dropdown-nav li a::before {
  content: '';
}

.dropdown-nav li a::after {
  content: '';
}

.dropdown-nav .link {
  color: #000;
}

 .mobile-nav-enter-active, 
 .mobile-nav-leave-active  {
  // transition: .5s ease all;
  transition: all .35s cubic-bezier(.62,.04,.3,1.56);
  //  transition-delay: .1s;
}

.mobile-nav-enter-from,
.mobile-nav-leave-to {
  width: 0%;
  // z-index: 10;
  opacity: 0;
 
}

.mobile-nav-enter-to {
  // width: 135%;
  width: 100%;  
  opacity: 1;
    // left: 35%;

}


.scrolled-nav {
  background-color: #fff;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .1);
  padding: 1rem 0.5rem;
  z-index: 9999;
}

.scrolled-nav a {
  color: #000;
}
.scrolled-nav .icon i {
  color: #000;
}

.scrolled-nav nav {
  padding-top: 8px;
  padding-bottom: 8px;
}

.scrolled-nav img {
    width: 45px;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
}

@media (min-width: 2250px){

  .logo a {
    font-size: 2.5rem;
  }

  a {
    font-size: 1.3rem;
  }

}

@media (max-width: 1440px) {
  .nav-container {
    width: 75%;
  }
}

@media (max-width: 1024px) {
   .nav-container {
    width: 90%;
  }

      li {
          padding: 0.15rem 0.7rem;
        }
      a {
          font-size: 1rem;
        }
}

@media (max-width: 880px) {
      .nav-container {
          width: 95%;
      }

      li {
          padding: 0.15rem 0.3rem;
      }
      a {
          font-size: 0.95rem;
        }
}



</style>
